import instanceQuery from 'graphql/queries/sales/DocumentConfigQuery.graphql';
import defaultQuery from 'graphql/queries/sales/DocumentConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/DocumentConfigMutation.graphql';
import fragment from 'graphql/fragments/sales/DocumentConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const DocumentConfig: Omit<EntityType, 'formUrl' | 'screenReference'> & {
  formUrlSales: string;
  formUrlPurchasing: string;
  formUrlProduct: string;
  screenReferenceSales: string;
  screenReferencePurchasing: string;
  screenReferenceProduct: string;
} = {
  type: 'DocumentConfig',
  title: 'Document Configuration',
  formUrlSales: '/Sales/Configuration/',
  formUrlPurchasing: '/Purchasing/Configuration/',
  formUrlProduct: '/Products/Configuration/',
  formTitle: 'Document Configuration',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReferenceSales: 'SALES_DOCUMENT_CONFIG',
  screenReferencePurchasing: 'PURCHASES_DOCUMENT_CONFIG',
  screenReferenceProduct: 'PRODUCT_DOCUMENT_CONFIG',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default DocumentConfig;
